import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Event } from "../../../pojo/Event";
import { ModalInterface } from "../modal.interface";
import { ModalData } from "../modal.service";

@Component({
    template: `
        <div class="s25-ng">
            <s25-modal-header [data]="data"></s25-modal-header>
            <div class="modal-body">
                <s25-ng-event-form-preview
                    [formModel]="data.formModel"
                    [consolidatedOccObj]="true"
                ></s25-ng-event-form-preview>
            </div>
            <div class="modal-footer"></div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEventFormPreviewComponent implements ModalInterface {
    @Input() data: ModalData & { formModel: Event.Form };
}
